import { render, staticRenderFns } from "./client-journal-table.vue?vue&type=template&id=8aa5776c&scoped=true"
import script from "./client-journal-table.vue?vue&type=script&lang=js"
export * from "./client-journal-table.vue?vue&type=script&lang=js"
import style0 from "./client-journal-table.vue?vue&type=style&index=0&id=8aa5776c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa5776c",
  null
  
)

export default component.exports